import React from 'react';
import PropTypes from 'prop-types';
import QAsection from './QAsection';

/**
 * FaqSection  Component
 *
 */
const FaqSection = function FaqSection(props) {
    const sectContentData = props.sectContent;
    const {title} = props;
    const titleID = title.replace(/ |\(|\)/g, '-').toLowerCase();
    const sectContent = sectContentData.map((item, index) => {
        const {question, answer} = item;
        return (
            <QAsection
                key={question}
                question={question}
                answer={answer} />
        );
    });
    return (
        <section id={titleID} className="section">
            <div className="row content">
                <div className="col-xs-12">
                    <h2 className="font_0">{title}</h2>
                </div>
            </div>
            {sectContent}
        </section>
    );
};

FaqSection.propTypes = {
    title: PropTypes.string,
    sectContent: PropTypes.array
};

export default FaqSection;
